import React from "react"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import List from "@mui/material/List"
import Typography from "@mui/material/Typography"
import useTickets from "../../../hooks/useTickets"
import TicketListItem from "../../../components/TicketListItem"

function UnreadedMessages() {
    const { tickets } = useTickets({ withUnreadMessages: "true" })

    return (
        <Card
            sx={{
                borderRadius: 2,
                boxShadow: 1,
                height: 355,
                overflowY: "auto",
            }}
        >
            <CardContent>
                <Typography variant="h6" color="text.secondary">
                    Mensagens não lidas
                </Typography>
                <List dense>
                    {tickets.map((ticket) => (
                        <TicketListItem
                            key={ticket.id}
                            ticket={ticket}
                            onTicketClick={() => {}}
                        />
                    ))}
                </List>
            </CardContent>
        </Card>
    )
}

export default UnreadedMessages
